import {
  FETCH_PROVIDER_INVOICES_REQUEST,
  FETCH_PROVIDER_INVOICES_SUCCESS,
  FETCH_PROVIDER_INVOICES_FAILURE,
} from "./actionTypes";

export const fetchProviderInvoicesRequest = () => ({
  type: FETCH_PROVIDER_INVOICES_REQUEST,
});

export const fetchProviderInvoicesSuccess = (items) => ({
  type: FETCH_PROVIDER_INVOICES_SUCCESS,
  payload: items,
});

export const fetchProviderInvoicesFailure = (error) => ({
  type: FETCH_PROVIDER_INVOICES_FAILURE,
  payload: error,
});